const types = {
  GET_CATEGORIES_START: 'GET_CATEGORIES_START',
  GET_CATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
  GET_CATEGORIES_FAILURE: 'GET_CATEGORIES_FAILURE',
  GET_ARTICLES_START: 'GET_ARTICLES_START',
  GET_ARTICLES_SUCCESS: 'GET_ARTICLES_SUCCESS',
  GET_ARTICLES_FAILURE: 'GET_ARTICLES_FAILURE',
  GET_ARTICLE_START: 'GET_ARTICLE_START',
  GET_ARTICLE_SUCCESS: 'GET_ARTICLE_SUCCESS',
  GET_ARTICLE_FAILURE: 'GET_ARTICLE_FAILURE',
  SUBMIT_ARTICLE_START: 'SUBMIT_ARTICLE_START',
  SUBMIT_ARTICLE_SUCCESS: 'SUBMIT_ARTICLE_SUCCESS',
  SUBMIT_ARTICLE_FAILURE: 'SUBMIT_ARTICLE_FAILURE',
  SUBMIT_ARTICLE_BANNER_START: 'SUBMIT_ARTICLE_BANNER_START',
  SUBMIT_ARTICLE_BANNER_SUCCESS: 'SUBMIT_ARTICLE_BANNER_SUCCESS',
  SUBMIT_ARTICLE_BANNER_FAILURE: 'SUBMIT_ARTICLE_BANNER_FAILURE',
  GET_ARTICLE_BANNER_START: 'GET_ARTICLE_BANNER_START',
  GET_ARTICLE_BANNER_SUCCESS: 'GET_ARTICLE_BANNER_SUCCESS',
  GET_ARTICLE_BANNER_FAILURE: 'GET_ARTICLE_BANNER_FAILURE',
  GET_ALL_BANNER_ADS_START: 'GET_ALL_BANNER_ADS_START',
  GET_ALL_BANNER_ADS_SUCCESS: 'GET_ALL_BANNER_ADS_SUCCESS',
  GET_ALL_BANNER_ADS_FAILURE: 'GET_ALL_BANNER_ADS_FAILURE',
};

export default types;
